import React, { useState } from "react";

const UploadRepository = (props) => {
    const { repoDocs = [], setSelectedRepoDocs, loading = false } = props;
    const [selectedDocs, setSelectedDocs] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const handleToggleDoc = (item) => {
        const existingDocs = [...selectedDocs];
        const index = existingDocs.findIndex((x) => x.id === item.id);
        if (index > -1) {
            existingDocs.splice(index, 1);
        } else {
            existingDocs.push(item);
        }
        setSelectedDocs(existingDocs);
        setSelectedRepoDocs(existingDocs);
    };

    const getFileIconDetails = (fileName) => {
        const ext = fileName?.split(".").pop().toLowerCase();
        switch (ext) {
            case "pdf":
                return { icon: "fa fa-file-pdf-o", color: "#ef4444", bg: "#fef2f2", border: "#fee2e2" };
            case "docx":
            case "doc":
                return { icon: "fa fa-file-word-o", color: "#2563eb", bg: "#eff6ff", border: "#dbeafe" };
            case "xlsx":
            case "xls":
            case "csv":
                return { icon: "fa fa-file-excel-o", color: "#16a34a", bg: "#f0fdf4", border: "#dcfce7" };
            case "jpg":
            case "jpeg":
            case "png":
            case "gif":
            case "svg":
                return { icon: "fa fa-file-image-o", color: "#8b5cf6", bg: "#f5f3ff", border: "#ede9fe" };
            default:
                return { icon: "fa fa-file-o", color: "#64748b", bg: "#f8fafc", border: "#e2e8f0" };
        }
    };

    // Filter repository docs by search query
    const filteredDocs = repoDocs.filter((doc) =>
        doc.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        doc.id?.toString().includes(searchQuery)
    );

    return (
        <>
            <style>{`
                .ur-shell,
                .ur-shell button,
                .ur-shell input {
                    font-family: "Open Sans", "Segoe UI", Roboto, sans-serif !important;
                }
                .ur-container {
                    display: flex;
                    flex-direction: column;
                    gap: 14px;
                    width: 100%;
                }
                .ur-toolbar {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 12px;
                    width: 100%;
                }
                .ur-search-wrapper {
                    position: relative;
                    flex: 1;
                    min-width: 0;
                }
                .ur-search-input {
                    width: 100%;
                    height: 38px;
                    padding: 8px 12px 8px 36px;
                    border-radius: 8px;
                    border: 1px solid #cbd5e1;
                    background-color: #ffffff;
                    color: #0f172a;
                    font-size: 13px;
                    font-weight: 600;
                    transition: all 0.15s ease;
                    outline: none;
                }
                .ur-search-input:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
                }
                .ur-search-icon {
                    position: absolute;
                    left: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #64748b;
                    font-size: 13px;
                    pointer-events: none;
                }
                .ur-add-btn {
                    height: 38px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 8px 14px;
                    border-radius: 8px;
                    font-size: 12.5px;
                    font-weight: 700;
                    border: 1px solid #cbd5e1;
                    background: #ffffff;
                    color: #475569;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    white-space: nowrap;
                    text-decoration: none !important;
                }
                .ur-add-btn:hover {
                    background: #f8fafc;
                    border-color: #94a3b8;
                    color: #0f172a;
                    transform: translateY(-1px);
                }
                .ur-list-scroll {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    max-height: 480px;
                    min-height: 180px;
                    overflow-y: auto;
                    padding: 2px;
                    scrollbar-width: thin;
                    scrollbar-color: #cbd5e1 transparent;
                }
                .ur-list-scroll::-webkit-scrollbar {
                    width: 5px;
                }
                .ur-list-scroll::-webkit-scrollbar-track {
                    background: transparent;
                }
                .ur-list-scroll::-webkit-scrollbar-thumb {
                    background: #cbd5e1;
                    border-radius: 10px;
                }
                .ur-list-scroll::-webkit-scrollbar-thumb:hover {
                    background: #94a3b8;
                }
                .ur-card-row {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 14px;
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    user-select: none;
                    text-align: left;
                }
                .ur-card-row:hover {
                    border-color: #cbd5e1;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
                }
                .ur-card-row.selected {
                    background: #f8fbff;
                    border-color: #93c5fd;
                    border-left: 4px solid #2563eb;
                    padding-left: 11px;
                }
                .ur-checkbox-wrap {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 18px;
                    height: 18px;
                    flex-shrink: 0;
                }
                .ur-checkbox-custom {
                    width: 18px;
                    height: 18px;
                    border: 2px solid #cbd5e1;
                    border-radius: 4px;
                    transition: all 0.2s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .ur-checkbox-custom::after {
                    content: "";
                    display: none;
                    width: 5px;
                    height: 9px;
                    border: solid white;
                    border-width: 0 2px 2px 0;
                    transform: rotate(45deg);
                    margin-bottom: 2px;
                }
                .ur-card-row.selected .ur-checkbox-custom {
                    background-color: #2563eb;
                    border-color: #2563eb;
                }
                .ur-card-row.selected .ur-checkbox-custom::after {
                    display: block;
                }
                .ur-doc-icon {
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                    flex-shrink: 0;
                }
                .ur-doc-main {
                    flex: 1;
                    min-width: 0;
                }
                .ur-doc-title {
                    font-size: 13px;
                    font-weight: 700;
                    color: #1e293b;
                    margin: 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .ur-doc-meta {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-top: 4px;
                }
                .ur-meta-pill {
                    font-size: 10.5px;
                    font-weight: 700;
                    color: #64748b;
                    background: #f1f5f9;
                    padding: 1px 6px;
                    border-radius: 4px;
                    border: 1px solid #e2e8f0;
                }
                .ur-card-row.selected .ur-meta-pill {
                    background: #eff6ff;
                    color: #1d4ed8;
                    border-color: #dbeafe;
                }
                .ur-empty-state, .ur-loading-state {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    min-height: 180px;
                    border: 1px dashed #cbd5e1;
                    border-radius: 12px;
                    background: #f8fafc;
                    color: #64748b;
                    text-align: center;
                    padding: 24px;
                    gap: 8px;
                }
                .ur-empty-icon, .ur-loading-icon {
                    font-size: 24px;
                    color: #2563eb;
                    margin-bottom: 4px;
                }
                .ur-empty-title {
                    font-size: 13.5px;
                    font-weight: 800;
                    color: #0f172a;
                    margin: 0;
                }
                .ur-empty-desc {
                    font-size: 12px;
                    margin: 0;
                    color: #64748b;
                }
                @keyframes urPulse {
                    0%, 100% { opacity: 0.6; }
                    50% { opacity: 1; }
                }
                .ur-pulse {
                    animation: urPulse 1.5s infinite ease-in-out;
                }
            `}</style>

            <div className="ur-shell ur-container">
                <div className="ur-toolbar">
                    <div className="ur-search-wrapper">
                        <i className="fa fa-search ur-search-icon" />
                        <input
                            type="text"
                            placeholder="Search repository files..."
                            className="ur-search-input"
                            value={searchQuery}
                            onChange={({ target }) => setSearchQuery(target.value)}
                        />
                    </div>
                    <a
                        className="ur-add-btn"
                        href={`${process?.env?.REACT_APP_DDRMS_PORTAL_BASEURL}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="fa fa-plus" /> Add Document
                    </a>
                </div>

                <div className="ur-list-scroll">
                    {loading ? (
                        <div className="ur-loading-state ur-pulse">
                            <i className="fa fa-circle-o-notch fa-spin ur-loading-icon" />
                            <div className="ur-empty-title">Loading Repository...</div>
                            <div className="ur-empty-desc">Fetching files from DDRMS secure store</div>
                        </div>
                    ) : repoDocs.length === 0 ? (
                        <div className="ur-empty-state">
                            <i className="fa fa-folder-open-o ur-empty-icon" />
                            <div className="ur-empty-title">DDRMS Repository Empty</div>
                            <div className="ur-empty-desc">No files are currently associated with this candidate</div>
                        </div>
                    ) : filteredDocs.length === 0 ? (
                        <div className="ur-empty-state">
                            <i className="fa fa-search ur-empty-icon" style={{ color: "#64748b" }} />
                            <div className="ur-empty-title">No Search Results</div>
                            <div className="ur-empty-desc">Try searching for a different keyword or file ID</div>
                        </div>
                    ) : (
                        filteredDocs.map((item) => {
                            const isSelected = selectedDocs.some((x) => x.id === item.id);
                            const details = getFileIconDetails(item.name || "");
                            return (
                                <div
                                    key={item.id}
                                    className={`ur-card-row ${isSelected ? "selected" : ""}`}
                                    onClick={() => handleToggleDoc(item)}
                                >
                                    <span className="ur-checkbox-wrap">
                                        <span className="ur-checkbox-custom" />
                                    </span>
                                    <div
                                        className="ur-doc-icon"
                                        style={{
                                            background: isSelected ? "#ffffff" : details.bg,
                                            border: "1px solid " + details.border,
                                            color: details.color,
                                        }}
                                    >
                                        <i className={details.icon} />
                                    </div>
                                    <div className="ur-doc-main">
                                        <h4 className="ur-doc-title" title={item.name}>
                                            {item.name}
                                        </h4>
                                        <div className="ur-doc-meta">
                                            <span className="ur-meta-pill">ID: {item.id}</span>
                                            {item.fileExtension && (
                                                <span className="ur-meta-pill text-uppercase">
                                                    {item.fileExtension}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </>
    );
};

export default UploadRepository;